import { PROCESS_STATUS } from 'consts/processStatus';
import type { HTTP } from 'services/http';

export function getInfoboxMessageForStatus(processStatus: number) {
	switch (processStatus) {
		case PROCESS_STATUS.InSigning:
			return 'contract_sended';
		case PROCESS_STATUS.PrintedContractForManualSigning:
			return 'contract_printed';
		default:
			return '';
	}
}

export function startSigning(
	http: HTTP,
	id: string,
	endpoint: string,
	message: string,
	isManualSigning = false
) {
	const queryString = isManualSigning ? '?isManualSigning=true' : '';
	const url = `${endpoint}/${id}${queryString}`;
	return http.post(url, {}, message);
}

export function getSigningIdInLoop<T = unknown>(http: HTTP, url: string) {
	return new Promise<T>((resolve, reject) => {
		pollSigningId(http, url, resolve, reject);
	});
}

function pollSigningId<T = unknown>(
	http: HTTP,
	url: string,
	resolve: (res: T) => void,
	reject: (reason?: unknown) => void
) {
	const pathname = globalThis.location.pathname;
	if (!pathname.endsWith('/sign') && !pathname.endsWith('/sign/')) {
		return reject('SIGNING SKIPPED: url changed');
	}

	http
		.get<T>(url)
		.then(res => {
			const signingId = (res as unknown as { processInfo?: { signingId?: string } })?.processInfo?.signingId;
			if (signingId?.length) {
				resolve(res);
				return;
			}

			setTimeout(() => pollSigningId(http, url, resolve, reject), 9_000);
		})
		.catch(reject);
}

export function submitRedirect(url: string, values: Record<string, string>) {
	const form = document.createElement('form');
	form.action = url;
	form.method = 'POST';
	form.style.display = 'none';
	appendHiddenFields(form, values);

	const body = document.body;
	if (!body) {
		throw new Error('Unable to submit redirect: document body is not available');
	}

	body.appendChild(form);
	form.submit();
}

function appendHiddenFields(form: HTMLFormElement, values: Record<string, string>) {
	for (const [name, value] of Object.entries(values)) {
		appendHiddenField(form, name, value);
	}
}

function appendHiddenField(form: HTMLFormElement, name: string, value: string) {
	const input = document.createElement('input');
	input.type = 'hidden';
	input.name = name;
	input.value = value;
	form.appendChild(input);
}
